import {Card} from "primereact/card";
import {
    useTargetKPIResponsible,
    useTargetYTDActual, useTargetYTDActualUnformatted,
    useTargetYTDGoal,
    useTargetYTDGoalUnformatted
} from "../../hooks/kpiHooks";
import {Link} from "react-router-dom";

const KPIValueTargetCard = ({target, path, showScoreboardTag}) => {
    const targetResponsible = useTargetKPIResponsible(target);
    const ytdGoal = useTargetYTDGoal(target);
    const ytdActual = useTargetYTDActual(target);
    const ytdGoalUnformatted = useTargetYTDGoalUnformatted(target);
    const ytdActualUnformatted = useTargetYTDActualUnformatted(target);
    const label = target?.timeFrame === 'Quarter' ? `${target?.quarter} Actual` : 'YTD';
    const goalLabel = target?.timeFrame === 'Quarter' ? target?.quarter : 'YTD';
    const percent = target.improvementDirection === 'Higher' ? ((ytdActualUnformatted / ytdGoalUnformatted) * 100.0).toFixed(1) :
        ((ytdGoalUnformatted / ytdActualUnformatted) * 100.0).toFixed(1);
    const goingUp = target.improvementDirection === 'Higher' ? ytdGoalUnformatted <= (ytdActualUnformatted) :
        ytdGoalUnformatted >= (ytdActualUnformatted);
    const equal = ytdGoalUnformatted === (ytdActualUnformatted);

    return (
        <Link className="kpi-value-target-link" to={`${path}/popup/${target.id}`}>
            <Card className="kpi-value-target">
                <div className="kpi-name">{target.name}</div>
                {showScoreboardTag && target?.scorecard && (<div className="kpi-scorecard-item">Scoreboard Goal</div>)}
                <div className="kpi-responsible">{targetResponsible}</div>
                <div className="kpi-ytd-actual">{ytdActual} {label}</div>
                <div className="kpi-ytd-goal">
                    {ytdGoal} {goalLabel} Goal
                    <i className={equal ? `fa-light fa-dash okay` : `pi ${goingUp ? 'pi-arrow-up great' : 'pi-arrow-down bad'}`}></i>
                </div>
                <div className="kpi-current-percent">{`${percent}%`}</div>
            </Card>
        </Link>
    )
}

export default KPIValueTargetCard
